import React from "react";
import "./Blog.css";

const Blog = () => {
  return (
    <div id="blogsComp" className="blogComp">
      <h1 id="slogan" className="blogHeading">
        Blogs:
      </h1>
      <div className="blogRow1">
        <div class="Blogcard">
          <div class="Blogcard2">
            <div className="blogImg blogImg1"></div>
            <h2 className="blogName">Weight Training</h2>
            <a href="https://www.healthline.com/health/how-to-start-lifting-weights" target="_blank"><button className="blogBtn">Read!</button></a>
          </div>
        </div>

        <div class="Blogcard">
          <div class="Blogcard2">
            <div className="blogImg blogImg2"></div>
            <h2 className="blogName">Gym Diet</h2>
            <a href="https://www.healthifyme.com/blog/the-ultimate-7-day-gym-diet-plan/" target="_blank"><button className="blogBtn">Read!</button></a>
          </div>
        </div>

        <div class="Blogcard">
          <div class="Blogcard2">
            <div className="blogImg blogImg3"></div>
            <h2 className="blogName">Cardio</h2>
            <a href="https://www.puregym.com/blog/the-best-gym-cardio-workout-plans/" target="_blank"><button className="blogBtn">Read!</button></a>
          </div>
        </div>
      </div>
      <div className="blogRow1">
        <div class="Blogcard">
          <div class="Blogcard2">
            <div className="blogImg blogImg4"></div>
            <h2 className="blogName">Yoga</h2>
            <a href="https://dailycupofyoga.com/" target="_blank"><button className="blogBtn">Read!</button></a>
          </div>
        </div>

        <div class="Blogcard">
          <div class="Blogcard2">
            <div className="blogImg blogImg5"></div>
            <h2 className="blogName">Bulking</h2>
            <a href="https://www.myprotein.co.in/blog/nutrition/bulking-how-to-bulk-tips-2/" target="_blank"><button className="blogBtn">Read!</button></a>
          </div>
        </div>

        <div class="Blogcard">
          <div class="Blogcard2">
            <div className="blogImg blogImg6"></div>
            <h2 className="blogName">Workout Routine</h2>
            <a href="https://www.aworkoutroutine.com/blog/" target="_blank"><button className="blogBtn">Read!</button></a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
